import React from 'react';
import { useTranslation } from 'react-i18next';
import { DsTag } from '@tokenyico/design-system/dist/reactJS';

export default ({ status, ...rest }) => {
  const { t } = useTranslation();

  const versions = {
    INITIATED: 'warning',
    PENDING: 'warning',
    PENDING_TO_ACCEPT: 'warning',
    BLOCKING: 'warning',
    BLOCK_FAILED: 'error',
    UNBLOCKING_BY_ISSUER: 'warning',
    UNBLOCKING_BY_INVESTOR: 'warning',
    UNBLOCKING: 'warning',
    UNBLOCK_FAILED: 'error',
    CANCELED_BY_INVESTOR: 'error',
    CANCELED_BY_ISSUER: 'error',
    CANCEL_REQUESTED: 'warning',
    PAYMENT_SENT: 'success',
    BURN_IN_PROGRESS: 'warning',
    BURN_FAILED: 'error',
    REDEEMED: 'info',
  };

  const icons = {
    INITIATED: 'pending',
    PENDING: 'pending',
    PENDING_TO_ACCEPT: 'pending',
    BLOCKING: 'loader-circle',
    BLOCK_FAILED: 'cross-circle',
    UNBLOCKING_BY_ISSUER: 'loader-circle',
    UNBLOCKING_BY_INVESTOR: 'loader-circle',
    UNBLOCKING: 'loader-circle',
    UNBLOCK_FAILED: 'cross-circle',
    CANCELED_BY_INVESTOR: 'cross-circle',
    CANCELED_BY_ISSUER: 'cross-circle',
    CANCEL_REQUESTED: 'pending',
    PAYMENT_SENT: 'verified',
    BURN_IN_PROGRESS: 'loader-circle',
    BURN_FAILED: 'cross-circle',
    REDEEMED: 'undo',
  };

  const label = {
    INITIATED: t('shared.initiated'),
    PENDING: t('shared.pendingPayment'),
    PENDING_TO_ACCEPT: t('shared.pending'),
    BLOCKING: t('shared.blocking'),
    BLOCK_FAILED: t('shared.blockFailed'),
    UNBLOCKING_BY_ISSUER: t('shared.unblocking'),
    UNBLOCKING_BY_INVESTOR: t('shared.unblocking'),
    UNBLOCKING: t('shared.unblocking'),
    UNBLOCK_FAILED: t('shared.unblockFailed'),
    CANCELED_BY_INVESTOR: t('shared.canceledByInvestor'),
    CANCELED_BY_ISSUER: t('shared.canceledByIssuer'),
    CANCEL_REQUESTED: t('shared.cancelRequested'),
    PAYMENT_SENT: t('shared.paymentSent'),
    BURN_IN_PROGRESS: t('shared.burnInProgress'),
    BURN_FAILED: t('shared.burnFailed'),
    REDEEMED: t('shared.redeemed'),
  };

  return (
    <DsTag
      label={label[status]}
      version={versions[status] || 'default'}
      icon={icons[status]}
      iconSize="14px"
      size="xs"
      style={{ cursor: 'pointer' }}
      {...rest}
    />
  );
};
